import React, { Component } from 'react'
import { getToken } from '../lib'

/**
 *
 *
 * @export
 * @param {react Object} Layout - The Layout component
 * @returns {react Object} The returned component, according to the authentication of the token.
 */
export default function authenticate (Layout) {
  class LoadProfileDetails extends Component {
    // state = {
    //   reditectToRefferal: false
    // };
    componentDidMount () {
      if (
        sessionStorage.getItem('authToken') ||
        localStorage.getItem('authToken')
      ) {
        const token = getToken()
        this.props.checkValidity(token).then(res => {
          if (res.errors) {
            console.error('token not valid')
            this.props.history.push('/login')
            // this.setState({ reditectToRefferal: true });
          } else {
            this.props.returnUserIfUserExists(token)
            // this.setState({ reditectToRefferal: false });
          }
        })
      }
    }

    componentWillReceiveProps (nextProps) {
      if (nextProps.location.pathname !== this.props.location.pathname) {
        if (
          sessionStorage.getItem('authToken') ||
          localStorage.getItem('authToken')
        ) {
          const token = getToken()
          this.props.checkTokenOnPathChange(token).then(res => {
            if (res.errors) {
              console.error('token not valid in here')
              this.props.history.push('/login')
              // this.setState({ reditectToRefferal: true });
            } else {
              // this.props.returnUserIfUserExists(token);
              // TODO:
              // this.setState({ reditectToRefferal: false });
            }
          })
        }
      }
    }

    render () {
      return <Layout {...this.props} />
    }
  }

  return LoadProfileDetails
}

export function checkIftokenExists (Layout) {
  class RedirectIfLoggedIn extends Component {
    componentDidMount () {
      if (
        sessionStorage.getItem('authToken') ||
        localStorage.getItem('authToken')
      ) {
        const token = getToken()
        this.props.checkValidity(token).then(res => {
          if (!res.errors) {
            this.props.history.push('/')
          } else {
            console.error('token not valid in logged out')
            this.props.recieveLoginstatus(false, {})
            sessionStorage.removeItem('authToken')
            localStorage.removeItem('authToken')
          }
        })
      }
    }

    render () {
      return <Layout {...this.props} />
    }
  }

  return RedirectIfLoggedIn
}



// WEBPACK FOOTER //
// ./src/layouts/authenticateHOC.js